module.exports = __webpack_public_path__ + "static/media/polaris-light.64109cf6.otf";


//////////////////
// WEBPACK FOOTER
// ./src/polaris-light.otf
// module id = ./src/polaris-light.otf
// module chunks = 0